import React, { useState } from 'react';
import './EventFeaturesManagement.css';

/**
 * 🎫 EVENT FEATURES MANAGEMENT COMPONENT 2025
 * 
 * Toggle-Sektion für Event Information Features nach Design-Guide:
 * - 1:1 Text-Edit-Design
 * - Event-spezifische Features (Free drinks, Networking, Certificate, etc.)
 * - Add/Remove-Funktionalität
 * - Spezifische Klassennamen für Event Features
 */
function EventFeaturesManagement({
    features,
    addFeature,
    removeFeature,
    updateFeature,
    editData
}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="event-features-management">
            {/* Toggle Header */}
            <div 
                className={`event-features-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
            >
                <div className="event-features-header-content">
                    <div className="event-features-header-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8 2L10 6H14L11 9L12 13L8 11L4 13L5 9L2 6H6L8 2Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
                            <circle cx="8" cy="8" r="1" fill="currentColor"/>
                        </svg>
                    </div>
                    <h3 className="event-features-header-title">Event Features</h3>
                    <div className="event-features-counter">
                        {features?.length || 0}
                    </div>
                </div>
                <div className={`event-features-toggle-arrow ${isExpanded ? 'expanded' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path 
                            d="M4 6L8 10L12 6" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* Expanded Content */}
            {isExpanded && (
                <div className="event-features-content">
                    {/* Add Feature Button */}
                    <div className="add-feature-section">
                        <button onClick={addFeature} className="add-feature-btn">
                            <div className="btn-icon">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M7 3V11M3 7H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                            </div>
                            <span>Add Event Feature</span>
                        </button>
                    </div>

                    {/* Features Grid */}
                    {features && features.length > 0 && (
                        <div className="features-grid">
                            {features.map((feature, index) => (
                                <div key={feature.id || index} className="feature-edit-card">
                                    <div className="feature-edit-content">
                                        <div className="feature-edit-header">
                                            <div className="feature-number">
                                                <span>{index + 1}</span>
                                            </div>
                                            <button
                                                onClick={() => removeFeature(index)}
                                                className="feature-remove-btn"
                                                title="Remove Feature"
                                            >
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                                </svg>
                                            </button>
                                        </div>

                                        <div className="feature-edit-input">
                                            <textarea
                                                value={feature.text || ''}
                                                onChange={(e) => updateFeature(index, e.target.value)}
                                                placeholder="Enter event feature..."
                                                rows={2}
                                                className="feature-textarea"
                                            />
                                        </div>

                                        {/* Feature Preview - Event Style */}
                                        <div className="feature-preview">
                                            <div className="feature-preview-icon">
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <path d="M10 3L4.5 8.5L2 6" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </div>
                                            <span className="feature-preview-text">
                                                {feature.text || 'Enter feature text...'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Empty State - Event Specific */}
                    {(!features || features.length === 0) && (
                        <div className="empty-state">
                            <div className="empty-state-icon">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <path d="M24 6L28 18H42L32 26L36 38L24 32L12 38L16 26L6 18H20L24 6Z" stroke="#d1d5db" strokeWidth="2" strokeLinejoin="round"/>
                                    <circle cx="24" cy="24" r="2" fill="#d1d5db"/>
                                </svg>
                            </div>
                            <h4>No Event Features Yet</h4>
                            <p>Add features like "Free Drinks", "Networking", "Certificate", "Materials" etc.</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default EventFeaturesManagement;
